import { useSubscriptionByChannelIdQuery } from '@/entities/billing';
import { ApiError } from '@/shared/api/ApiError';
import { ISubscriptionResponseDto } from '@/shared/api/subscriptions';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export const useChannelSubscriptionState = (channelId: string) => {
  return useAppQuery<ISubscriptionResponseDto, ApiError>({
    ...useSubscriptionByChannelIdQuery(channelId),
    customError: true,
    enabled: Boolean(channelId),
  });
};
